import React, { useEffect } from 'react';
// TODO: (D.K.) Necessary make refactoring of this part of the functionality is needed (to get rid of react-redux)
// eslint-disable-next-line no-restricted-imports
import { useSelector } from 'react-redux';
import { CloseIcon } from '@yme/assets/icons';
import { BTN_LIGHT_THEME, ICON_ONLY, SIZE_36, TEXT_VARIANT } from '@yme/atoms/button';
import { Gallery } from '@yme/atoms/gallery';
import { useLockBodyScroll, useOutsideClick } from '@yme/hooks/index';
import { PRODUCT_PHOTO_DISCLAIMER_KEY } from '@yme/selectors/constants';
import { getAttribute } from '@yme/selectors/products';
import { toStringArray } from '@yme/utils/common';
import { EVENT_NAME_MAP, keyCodes } from '@yme/utils/constants';
import { galleryConfig } from './constants';
import { CloseButton, LightboxContainer, LightboxHeader, Overlay } from './styled';
export function Lightbox({ labels, closeLightbox, isRightToLeft, initialIndex, context, }) {
    const photoDisclaimer = useSelector(getAttribute(PRODUCT_PHOTO_DISCLAIMER_KEY));
    const photoDisclaimers = toStringArray(photoDisclaimer);
    const { elementRef } = useOutsideClick({
        eventName: EVENT_NAME_MAP.mouseDown,
        callback: closeLightbox,
    });
    useLockBodyScroll();
    const escCloseHandler = (event) => {
        if (event.code === keyCodes.ESCAPE) {
            closeLightbox();
        }
    };
    useEffect(() => {
        document.addEventListener('keydown', escCloseHandler);
        return () => {
            document.removeEventListener('keydown', escCloseHandler);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (React.createElement(Overlay, null,
        React.createElement(LightboxContainer, { ref: elementRef },
            React.createElement(LightboxHeader, null,
                labels.title,
                React.createElement(CloseButton, { buttonVariant: TEXT_VARIANT, hasIconButton: ICON_ONLY, iconComponent: CloseIcon, onClick: closeLightbox, colorSchema: BTN_LIGHT_THEME, label: labels.close, size: SIZE_36, isRightToLeft: isRightToLeft })),
            React.createElement(Gallery, { initialIndex: initialIndex, config: galleryConfig, context: context, photoDisclaimers: photoDisclaimers }))));
}
